import { useEffect, useState } from 'react';

export type PresencePhase = 'entering' | 'entered' | 'exiting';

interface UsePresenceOptions {
  duration?: number;
}

export function usePresence(
  isVisible: boolean,
  { duration = 200 }: UsePresenceOptions = {}
): {
  isMounted: boolean;
  phase: PresencePhase;
} {
  const [isMounted, setIsMounted] = useState(isVisible);
  const [phase, setPhase] = useState<PresencePhase>(isVisible ? 'entering' : 'exiting');

  useEffect(() => {
    let enterTimer: number | undefined;
    let exitTimer: number | undefined;

    if (isVisible) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsMounted(true);
      setPhase('entering');
      enterTimer = window.setTimeout(() => {
        setPhase('entered');
      }, 0);
    } else if (isMounted) {
      setPhase('exiting');
      exitTimer = window.setTimeout(() => {
        setIsMounted(false);
      }, duration);
    }

    return () => {
      if (enterTimer !== undefined) {
        window.clearTimeout(enterTimer);
      }
      if (exitTimer !== undefined) {
        window.clearTimeout(exitTimer);
      }
    };
  }, [duration, isMounted, isVisible]);

  return { isMounted, phase };
}
